// generated by Copilot and not reviewed line by line

package com.huanshankeji.compose.material.icons.automirrored.filled

import com.huanshankeji.compose.material.icons.Icon
import com.huanshankeji.compose.material.icons.Icons

actual val Icons.AutoMirrored.Filled.Accessible: Icon get() = Icon("accessible")
actual val Icons.AutoMirrored.Filled.AccessibleForward: Icon get() = Icon("accessible_forward")
actual val Icons.AutoMirrored.Filled.AirplaneTicket: Icon get() = Icon("airplane_ticket")
actual val Icons.AutoMirrored.Filled.AlignHorizontalLeft: Icon get() = Icon("align_horizontal_left")
actual val Icons.AutoMirrored.Filled.AlignHorizontalRight: Icon get() = Icon("align_horizontal_right")
actual val Icons.AutoMirrored.Filled.AltRoute: Icon get() = Icon("alt_route")
actual val Icons.AutoMirrored.Filled.ArrowBackIos: Icon get() = Icon("arrow_back_ios")
actual val Icons.AutoMirrored.Filled.ArrowForwardIos: Icon get() = Icon("arrow_forward_ios")
actual val Icons.AutoMirrored.Filled.ArrowLeft: Icon get() = Icon("arrow_left")
actual val Icons.AutoMirrored.Filled.ArrowRight: Icon get() = Icon("arrow_right")
actual val Icons.AutoMirrored.Filled.ArrowRightAlt: Icon get() = Icon("arrow_right_alt")
actual val Icons.AutoMirrored.Filled.Article: Icon get() = Icon("article")
actual val Icons.AutoMirrored.Filled.Assignment: Icon get() = Icon("assignment")
actual val Icons.AutoMirrored.Filled.AssignmentReturn: Icon get() = Icon("assignment_return")
actual val Icons.AutoMirrored.Filled.AssistantDirection: Icon get() = Icon("assistant_direction")
actual val Icons.AutoMirrored.Filled.Backspace: Icon get() = Icon("backspace")
actual val Icons.AutoMirrored.Filled.BatteryUnknown: Icon get() = Icon("battery_unknown")
actual val Icons.AutoMirrored.Filled.BluetoothSearching: Icon get() = Icon("bluetooth_searching")
actual val Icons.AutoMirrored.Filled.BrandingWatermark: Icon get() = Icon("branding_watermark")
actual val Icons.AutoMirrored.Filled.CallMade: Icon get() = Icon("call_made")
actual val Icons.AutoMirrored.Filled.CallMerge: Icon get() = Icon("call_merge")
actual val Icons.AutoMirrored.Filled.CallMissed: Icon get() = Icon("call_missed")
actual val Icons.AutoMirrored.Filled.CallMissedOutgoing: Icon get() = Icon("call_missed_outgoing")
actual val Icons.AutoMirrored.Filled.CallReceived: Icon get() = Icon("call_received")
actual val Icons.AutoMirrored.Filled.CallSplit: Icon get() = Icon("call_split")
actual val Icons.AutoMirrored.Filled.Chat: Icon get() = Icon("chat")
actual val Icons.AutoMirrored.Filled.ChromeReaderMode: Icon get() = Icon("chrome_reader_mode")
actual val Icons.AutoMirrored.Filled.Comment: Icon get() = Icon("comment")
actual val Icons.AutoMirrored.Filled.CompareArrows: Icon get() = Icon("compare_arrows")
actual val Icons.AutoMirrored.Filled.ContactSupport: Icon get() = Icon("contact_support")
actual val Icons.AutoMirrored.Filled.DirectionsBike: Icon get() = Icon("directions_bike")
actual val Icons.AutoMirrored.Filled.DirectionsRun: Icon get() = Icon("directions_run")
actual val Icons.AutoMirrored.Filled.DirectionsWalk: Icon get() = Icon("directions_walk")
actual val Icons.AutoMirrored.Filled.DriveFileMove: Icon get() = Icon("drive_file_move")
actual val Icons.AutoMirrored.Filled.Dvr: Icon get() = Icon("dvr")
actual val Icons.AutoMirrored.Filled.EventNote: Icon get() = Icon("event_note")
actual val Icons.AutoMirrored.Filled.FactCheck: Icon get() = Icon("fact_check")
actual val Icons.AutoMirrored.Filled.FeaturedPlayList: Icon get() = Icon("featured_play_list")
actual val Icons.AutoMirrored.Filled.FeaturedVideo: Icon get() = Icon("featured_video")
actual val Icons.AutoMirrored.Filled.Feed: Icon get() = Icon("feed")
actual val Icons.AutoMirrored.Filled.FollowTheSigns: Icon get() = Icon("follow_the_signs")
actual val Icons.AutoMirrored.Filled.FormatAlignLeft: Icon get() = Icon("format_align_left")
actual val Icons.AutoMirrored.Filled.FormatAlignRight: Icon get() = Icon("format_align_right")
actual val Icons.AutoMirrored.Filled.FormatIndentDecrease: Icon get() = Icon("format_indent_decrease")
actual val Icons.AutoMirrored.Filled.FormatIndentIncrease: Icon get() = Icon("format_indent_increase")
actual val Icons.AutoMirrored.Filled.FormatListBulleted: Icon get() = Icon("format_list_bulleted")
actual val Icons.AutoMirrored.Filled.FormatTextdirectionLToR: Icon get() = Icon("format_textdirection_l_to_r")
actual val Icons.AutoMirrored.Filled.FormatTextdirectionRToL: Icon get() = Icon("format_textdirection_r_to_l")
actual val Icons.AutoMirrored.Filled.Forward: Icon get() = Icon("forward")
actual val Icons.AutoMirrored.Filled.ForwardToInbox: Icon get() = Icon("forward_to_inbox")
actual val Icons.AutoMirrored.Filled.Grading: Icon get() = Icon("grading")
actual val Icons.AutoMirrored.Filled.Help: Icon get() = Icon("help")
actual val Icons.AutoMirrored.Filled.HelpCenter: Icon get() = Icon("help_center")
actual val Icons.AutoMirrored.Filled.Input: Icon get() = Icon("input")
actual val Icons.AutoMirrored.Filled.KeyboardBackspace: Icon get() = Icon("keyboard_backspace")
actual val Icons.AutoMirrored.Filled.KeyboardReturn: Icon get() = Icon("keyboard_return")
actual val Icons.AutoMirrored.Filled.KeyboardTab: Icon get() = Icon("keyboard_tab")
actual val Icons.AutoMirrored.Filled.Label: Icon get() = Icon("label")
actual val Icons.AutoMirrored.Filled.LabelImportant: Icon get() = Icon("label_important")
actual val Icons.AutoMirrored.Filled.LabelOff: Icon get() = Icon("label_off")
actual val Icons.AutoMirrored.Filled.LastPage: Icon get() = Icon("last_page")
actual val Icons.AutoMirrored.Filled.LibraryBooks: Icon get() = Icon("library_books")
actual val Icons.AutoMirrored.Filled.ListAlt: Icon get() = Icon("list_alt")
actual val Icons.AutoMirrored.Filled.LiveHelp: Icon get() = Icon("live_help")
actual val Icons.AutoMirrored.Filled.Login: Icon get() = Icon("login")
actual val Icons.AutoMirrored.Filled.Logout: Icon get() = Icon("logout")
actual val Icons.AutoMirrored.Filled.ManageSearch: Icon get() = Icon("manage_search")
actual val Icons.AutoMirrored.Filled.MenuBook: Icon get() = Icon("menu_book")
actual val Icons.AutoMirrored.Filled.MenuOpen: Icon get() = Icon("menu_open")
actual val Icons.AutoMirrored.Filled.MergeType: Icon get() = Icon("merge_type")
actual val Icons.AutoMirrored.Filled.MissedVideoCall: Icon get() = Icon("missed_video_call")
actual val Icons.AutoMirrored.Filled.More: Icon get() = Icon("more")
actual val Icons.AutoMirrored.Filled.MultilineChart: Icon get() = Icon("multiline_chart")
actual val Icons.AutoMirrored.Filled.NextPlan: Icon get() = Icon("next_plan")
actual val Icons.AutoMirrored.Filled.NextWeek: Icon get() = Icon("next_week")
actual val Icons.AutoMirrored.Filled.NotListedLocation: Icon get() = Icon("not_listed_location")
actual val Icons.AutoMirrored.Filled.Note: Icon get() = Icon("note")
actual val Icons.AutoMirrored.Filled.NoteAdd: Icon get() = Icon("note_add")
actual val Icons.AutoMirrored.Filled.Notes: Icon get() = Icon("notes")
actual val Icons.AutoMirrored.Filled.OpenInNew: Icon get() = Icon("open_in_new")
actual val Icons.AutoMirrored.Filled.Outbound: Icon get() = Icon("outbound")
actual val Icons.AutoMirrored.Filled.PhoneCallback: Icon get() = Icon("phone_callback")
actual val Icons.AutoMirrored.Filled.PhoneForwarded: Icon get() = Icon("phone_forwarded")
actual val Icons.AutoMirrored.Filled.PhoneMissed: Icon get() = Icon("phone_missed")
actual val Icons.AutoMirrored.Filled.PlaylistAdd: Icon get() = Icon("playlist_add")
actual val Icons.AutoMirrored.Filled.PlaylistAddCheck: Icon get() = Icon("playlist_add_check")
actual val Icons.AutoMirrored.Filled.PlaylistPlay: Icon get() = Icon("playlist_play")
actual val Icons.AutoMirrored.Filled.QueueMusic: Icon get() = Icon("queue_music")
actual val Icons.AutoMirrored.Filled.ReadMore: Icon get() = Icon("read_more")
actual val Icons.AutoMirrored.Filled.ReceiptLong: Icon get() = Icon("receipt_long")
actual val Icons.AutoMirrored.Filled.Redo: Icon get() = Icon("redo")
actual val Icons.AutoMirrored.Filled.Reply: Icon get() = Icon("reply")
actual val Icons.AutoMirrored.Filled.ReplyAll: Icon get() = Icon("reply_all")
actual val Icons.AutoMirrored.Filled.RotateLeft: Icon get() = Icon("rotate_left")
actual val Icons.AutoMirrored.Filled.RotateRight: Icon get() = Icon("rotate_right")
actual val Icons.AutoMirrored.Filled.Rtt: Icon get() = Icon("rtt")
actual val Icons.AutoMirrored.Filled.Rule: Icon get() = Icon("rule")
actual val Icons.AutoMirrored.Filled.ScheduleSend: Icon get() = Icon("schedule_send")
actual val Icons.AutoMirrored.Filled.ScreenShare: Icon get() = Icon("screen_share")
actual val Icons.AutoMirrored.Filled.Segment: Icon get() = Icon("segment")
actual val Icons.AutoMirrored.Filled.SendAndArchive: Icon get() = Icon("send_and_archive")
actual val Icons.AutoMirrored.Filled.ShortText: Icon get() = Icon("short_text")
actual val Icons.AutoMirrored.Filled.ShowChart: Icon get() = Icon("show_chart")
actual val Icons.AutoMirrored.Filled.Sort: Icon get() = Icon("sort")
actual val Icons.AutoMirrored.Filled.SpeakerNotes: Icon get() = Icon("speaker_notes")
actual val Icons.AutoMirrored.Filled.StarHalf: Icon get() = Icon("star_half")
actual val Icons.AutoMirrored.Filled.StickyNote2: Icon get() = Icon("sticky_note_2")
actual val Icons.AutoMirrored.Filled.StopScreenShare: Icon get() = Icon("stop_screen_share")
actual val Icons.AutoMirrored.Filled.Subject: Icon get() = Icon("subject")
actual val Icons.AutoMirrored.Filled.TextSnippet: Icon get() = Icon("text_snippet")
actual val Icons.AutoMirrored.Filled.Toc: Icon get() = Icon("toc")
actual val Icons.AutoMirrored.Filled.TrendingDown: Icon get() = Icon("trending_down")
actual val Icons.AutoMirrored.Filled.TrendingFlat: Icon get() = Icon("trending_flat")
actual val Icons.AutoMirrored.Filled.TrendingUp: Icon get() = Icon("trending_up")
actual val Icons.AutoMirrored.Filled.Undo: Icon get() = Icon("undo")
actual val Icons.AutoMirrored.Filled.ViewList: Icon get() = Icon("view_list")
actual val Icons.AutoMirrored.Filled.ViewQuilt: Icon get() = Icon("view_quilt")
actual val Icons.AutoMirrored.Filled.ViewSidebar: Icon get() = Icon("view_sidebar")
actual val Icons.AutoMirrored.Filled.VolumeDown: Icon get() = Icon("volume_down")
actual val Icons.AutoMirrored.Filled.VolumeMute: Icon get() = Icon("volume_mute")
actual val Icons.AutoMirrored.Filled.VolumeOff: Icon get() = Icon("volume_off")
actual val Icons.AutoMirrored.Filled.VolumeUp: Icon get() = Icon("volume_up")
actual val Icons.AutoMirrored.Filled.WrapText: Icon get() = Icon("wrap_text")
actual val Icons.AutoMirrored.Filled.Wysiwyg: Icon get() = Icon("wysiwyg")
actual val Icons.AutoMirrored.Filled._360: Icon get() = Icon("360")
